import s from './style.css';
import cn from 'classnames';
import { Component } from 'preact';
import Container from 'components/Container';

const reasons = [
	{ reason: 'Lost interest', size: 'small', style: 2 },
	{
		reason: 'People trying to cause trouble with lies',
		size: 'medium',
		style: 1
	},
	{ reason: 'She was married to a colleague', size: 'medium', style: 3 },
	{ reason: 'He got a new one', size: 'small', style: 4 },
	{ reason: 'Drifted apart', size: 'small', style: 1 },
	{ reason: 'Had to move to a different country', size: 'medium', style: 2 },
	{ reason: 'Found out he was married', size: 'medium', style: 4 },
	{ reason: 'She found someone else', size: 'small', style: 3 },
	{ reason: 'Disconnect of ambition', size: 'small', style: 2 }
];

const styles = [
	{ border: '#FECA98', fill: '#FFF2E6' },
	{ border: '#F1979A', fill: '#F6C1C2' },
	{ border: '#D8AC24', fill: '#FEE077' },
	{ border: '#709EEB', fill: '#C2D6F7' }
];

class BreakupMosaic extends Component {
	constructor(props) {
		super(props);
		this.state = {
			inView: true
		};
	}

	componentWillMount() {
		const threshold = 0.3;

		if (typeof window !== 'undefined') {
			this.observer = new IntersectionObserver(
				entries => {
					entries.forEach((entry, i) => {
						if (entry.intersectionRatio > threshold) {
							this.setState({ inView: true });
							this.observer.unobserve(this.viz);
						}
						else {
							this.setState({ inView: false });
						}
					});
				},
				{
					rootMargin: '0px',
					threshold
				}
			);
		}
	}

	componentDidMount() {
		this.observer.observe(this.viz);
	}

	componentWillUnmount() {
		this.observer.unobserve(this.viz);
	}

	render() {
		const { inView } = this.state;

		return (
			<div
				className={cn(s.root, { [s.inView]: inView })}
				id={'it-might-not-work-out'}
			>
				<Container>
					<p className={s.text}>
						Here are some of the many different reasons you gave for calling it
						quits with a work mate.
					</p>

					<div className={s.reasonsWrap}>
						<ul className={s.reasons} ref={elem => (this.viz = elem)}>
							{reasons.map(({ reason, size, style }, i) => (
								<li
									className={cn(
										s.heart,
										{ [s[size]]: true },
										{ [s[`style-${style}`]]: true }
									)}
									style={{
										transitionDelay: `${i * 0.2}s`
									}}
								>
									<svg className={s.bg} viewBox="0 0 70 70">
										<use
											xlinkHref="#heart"
											style={{
												fill: styles[style - 1].fill,
												color: styles[style - 1].border
											}}
										/>
									</svg>
									<span>"{reason}"</span>
								</li>
							))}
						</ul>
					</div>
				</Container>
			</div>
		);
	}
}

export default BreakupMosaic;



// WEBPACK FOOTER //
// ./components/BreakupMosaic/index.js